import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { useTenants } from '@/services/tenants/useTenants';
import { queryFunction, queryKey } from './query';

export const useListPartFinderReports = ({ onError }: { onError?: (error: Error) => void } = {}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useDataGridFetcher({
    queryKey: parameters => queryKey({ tenantId, ...parameters }),
    queryFn: parameters => queryFunction({ tenantId, ...parameters }),
    onError,
  });
};
